export const COMPANY_SETTINGS_URLS = {
  CONFIG_MASTER: '/config-master/',
  SETTINGS: '/settings/',
};
